import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Wizard = {
    OR: (
        <FormattedMessage
            id='Wizard.OR'
            description='Conjunction shown between alternative method choices on wizard screens'
            defaultMessage='or'
        />
    ),
    ADD_SLOT_MANUALLY: (
        <FormattedMessage
            id='Wizard.ADD_SLOT_MANUALLY'
            description='Title for the modal to add a SLOT manually'
            defaultMessage='Add SLOT manually'
        />
    ),
    SCAN_THE_FOLLOWING: (
        <FormattedMessage
            id='Wizard.SCAN_THE_FOLLOWING'
            description='Message telling the user to scan the items listed below'
            defaultMessage='Scan the following'
        />
    ),
    SLOT_INCOMPATIBLE_WITH_PARCELS: (
        <FormattedMessage
            id='Wizard.SLOT_INCOMPATIBLE_WITH_PARCELS'
            description='Warning shown when the selected SLOT is not available for the scanned parcels after availability is recalculated'
            defaultMessage='This SLOT cannot be used for the scanned parcels. Please select a different SLOT.'
        />
    ),
    SLOT_UNAVAILABLE_WARNING: (
        <FormattedMessage
            id='Wizard.SLOT_UNAVAILABLE_WARNING'
            description='Warning shown when the scanned target slot is not in the available slots list'
            defaultMessage='This SLOT is not available as a destination. Please scan a different SLOT.'
        />
    ),
    SHOP: {
        DEFAULT: (
            <FormattedMessage
                id='wizard.shop.default'
                defaultMessage='Shop'
            />
        )
    },
    RECYCLE: {
        CREATE_TRANSACTION: {
            TITLE: (
                <FormattedMessage
                    id='wizard.recycle.createTransaction.title'
                    description='Title for create recycle transaction screen'
                    defaultMessage='Recycle transaction'
                />
            ),
            NO_SUBMIT_STEP: (
                <FormattedMessage
                    id='wizard.recycle.createTransaction.noSubmitStep'
                    description='Error when the create recycle transaction screen has no submit step configured'
                    defaultMessage='No submit step is configured for this recycle transaction screen.'
                />
            ),
            NO_PRODUCT_SELECTED: (
                <FormattedMessage
                    id='wizard.recycle.createTransaction.noProductSelected'
                    description='Error when no product was selected for recycle transaction creation'
                    defaultMessage='No product was selected for recycling.'
                />
            ),
            MISSING_WORKFLOW_SETTINGS: (
                <FormattedMessage
                    id='wizard.recycle.createTransaction.missingWorkflowSettings'
                    description='Error when workflow settings are missing for recycle transaction creation'
                    defaultMessage='Missing workflow settings for recycle transaction creation.'
                />
            ),
            MISSING_KIOSK_CONTEXT: (
                <FormattedMessage
                    id='wizard.recycle.createTransaction.missingKioskContext'
                    description='Error when kiosk context is missing for recycle transaction creation'
                    defaultMessage='Missing kiosk context for recycle transaction creation.'
                />
            ),
            NO_AVAILABLE_SLOTS: (
                <FormattedMessage
                    id='wizard.recycle.createTransaction.noAvailableSlots'
                    description='Error when no slot is available for recycle transaction creation'
                    defaultMessage='No available SLOTs found for this product.'
                />
            ),
            FAILED: (
                <FormattedMessage
                    id='wizard.recycle.createTransaction.failed'
                    description='Error when recycle transaction creation fails'
                    defaultMessage='Failed to create recycle transaction.'
                />
            )
        }
    }
};
